import { config } from '@/src/config/app-config';

export const EventAudienceType = {
  GENERAL_PUBLIC: 'GENERAL_PUBLIC', // Deprecated
  AWS_PRIVATE_ENGAGEMENT: 'AWS_PRIVATE_ENGAGEMENT', // Soon to be deprecated - used by Classrooms, but they will migrate to AWS_CLASSROOMS_BUILDER_LABS
  AWS_BOOTCAMP: 'AWS_BOOTCAMP', // Deprecated
  AWS_INTERNAL: 'AWS_INTERNAL', // Deprecated
  CUSTOMER_INTERNAL: 'CUSTOMER_INTERNAL', // Deprecated
  TESTERS: 'TESTERS',
  INDIVIDUAL: 'INDIVIDUAL', // Deprecated
  SKILL_BUILDER_EVENT: 'SKILL_BUILDER_EVENT',
  AWS_CLASSROOMS_BUILDER_LABS: 'AWS_CLASSROOMS_BUILDER_LABS',
  INTERNAL: 'INTERNAL',
  PUBLIC: 'PUBLIC',
  PAID_ALA_CARTE: 'PAID_ALA_CARTE', // Deprecated
  GLOBAL_PARTNERS: 'GLOBAL_PARTNERS',
  AWS_EDUCATION: 'AWS_EDUCATION',
  RECRUITING: 'RECRUITING',
  ACI_EVENT: 'ACI_EVENT',
  SKILL_BUILDER_LEARNER_EVENT: 'SKILL_BUILDER_LEARNER_EVENT',
  SUMMIT: 'SUMMIT',
  SKILL_BUILDER_COHORT: 'SKILL_BUILDER_COHORT',
};

export const AudienceTypeBasedOnUserGroup = {
  SB_ADMIN: { [EventAudienceType.SKILL_BUILDER_EVENT]: true },
  SB_LEARNER: { [EventAudienceType.SKILL_BUILDER_LEARNER_EVENT]: true },
  CLASSROOM_ILT: {
    [EventAudienceType.AWS_CLASSROOMS_BUILDER_LABS]: true, // Handled in the backend. This should case should never be hit
  },
  FEDERATE_USER: {
    [EventAudienceType.SKILL_BUILDER_EVENT]: false,
    [EventAudienceType.INTERNAL]: true,
    [EventAudienceType.GLOBAL_PARTNERS]: false,
    [EventAudienceType.AWS_EDUCATION]: false,
    ...(config.enableACIEvents && { [EventAudienceType.ACI_EVENT]: false }),
    [EventAudienceType.SUMMIT]: false,
  },
  JAM_ADMIN_USER: {
    [EventAudienceType.SKILL_BUILDER_EVENT]: false,
    [EventAudienceType.AWS_CLASSROOMS_BUILDER_LABS]: false,
    [EventAudienceType.INTERNAL]: true,
    [EventAudienceType.PUBLIC]: false,
    [EventAudienceType.GLOBAL_PARTNERS]: false,
    [EventAudienceType.AWS_EDUCATION]: false,
    [EventAudienceType.RECRUITING]: false,
    [EventAudienceType.SKILL_BUILDER_LEARNER_EVENT]: false,
    ...(config.enableACIEvents && { [EventAudienceType.ACI_EVENT]: false }),
    [EventAudienceType.SUMMIT]: false,
  },
};

export const EventAudienceTypeDescriptions = {
  GENERAL_PUBLIC: 'Open to the general public',
  AWS_PRIVATE_ENGAGEMENT: 'Private engagement facilitated by AWS Professional Services',
  AWS_BOOTCAMP: 'Instructor lead session included with an AWS Bootcamp',
  AWS_INTERNAL: 'Only accessible to AWS internal staff',
  CUSTOMER_INTERNAL: 'Facilitated by a customer without engagement from AWS',
  TESTERS: 'Only accessible to allowlisted users for testing',
  INDIVIDUAL: 'A single participant event, no teams',
  SKILL_BUILDER_LEARNER_EVENT: 'An event available only to customers with active Skill Builder Team Subscriptions',
  // TODO: Add descriptions for new channels
  SKILL_BUILDER_EVENT: '',
  AWS_CLASSROOMS_BUILDER_LABS: '',
  INTERNAL: '',
  PUBLIC: '',
  PAID_ALA_CARTE: '',
  GLOBAL_PARTNERS: '',
  AWS_EDUCATION: '',
  RECRUITING: '',
  ACI_EVENT: '',
  SUMMIT: '',
  SKILL_BUILDER_COHORT: 'A cohort-based event for Skill Builder subscribers',
};
